export default "__VITE_ASSET__DUZoRZP8__"